module.exports = __webpack_public_path__ + "static/media/marisa3.1deac00f.mp3";